import * as madnes from "../../framework/src/engine/madnes/madnes";
import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {set_show_money_pos_y} from "../../framework/src/engine/madnes/madnes_anims";
import {he} from "../../framework/src/engine/madnes/madnes_variables";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {
    ninestars_infomenu_close,
    ninestars_infomenu_init, ninestars_infomenu_left,
    ninestars_infomenu_open, ninestars_infomenu_right, ninestars_infomenu_update,
    ninestars_print_desk, openinfo
} from "../ninestars_reels";
import {ninestars_print_reels} from "../ninestars_core_printer";
import {ninestars_end_round_recalced, ninestars_rotate_run} from "../ninestars_core";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "cs", "de", "en", "es", "fi", "fr", "hr", "no", "pl", "ro", "ru", "sk", "sr", "sv", "tr","pt", "es-mx", "bg", "it"
];

export function initGame(gameset) {

    madnes.set_ico_size(350, 244 - 60);

    madnes_set_win_factors(25, 50, 125);
    // madnes_set_native_sceen_size(1280, 720);

    set_show_money_pos_y(he * 0.44);

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 350, 244);
    madnes_set_sprite('_blur', 350, 244);
    madnes_set_sprite('bigwin_background_sprite', 1280 / 2, 500 / 2);
    madnes_set_sprite('bigwin_x2_background_sprite', 798, 340);

    madnes_set_default_volume(0.8);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            // ninestars_end_round_recalced()
            ninestars_infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function on_set_bet() {
    infomenu_update();
}

export function initLoad() {}

export function game_start() {
    main_phaser.time.desiredFps = 120;
    ninestars_rotate_run();
}

export function print_desk() {
    ninestars_print_desk();
}

export function print_reels() {
    ninestars_print_reels();
}

export function infomenu_init() {
    ninestars_infomenu_init();
}

export function infomenu_open() {
    infomenu_update();
    ninestars_infomenu_open();
}

export function infomenu_close() {
    ninestars_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    ninestars_infomenu_left();
}

export function infomenu_right() {
    ninestars_infomenu_right();
}

export function infomenu_update() {
    ninestars_infomenu_update();
}

export function end_round_recalced(eventName, {autostart}) {
    ninestars_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {
}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}
